module.exports = "/src/views/player/reports/palaca.png";